import React from 'react'
import classNames from 'classnames'

import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import Grid, { GridProps } from '@material-ui/core/Grid'

import Coin from 'components/Coin'
import GameCardContent from '../GameCardContent'

import defaultAvatar from 'assets/images/default_user_avatar.png'

interface Props extends GridProps {
  name?: string
  photoUrl?: string
  entryFee?: number
}

const styles = createStyles({
  separator: {
    width: 1,
    height: '50%',
    opacity: .2,
    background: 'linear-gradient(top, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 1) 50%, rgba(255, 255, 255, 0) 100%)',
    marginLeft: 10,
    marginRight: 10,
  },
  entryFee: {
    fontSize: 36,
    fontWeight: 500,
  },
  entryFeeCurrency: {
    fontSize: 14,
    fontWeight: 700,
    marginTop: -15
  },
  padded: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  avatar: {
    width: 36,
    height: 36,
    border: '2px solid white',
  },
  title: {
    fontSize: 12,
    lineHeight: 1.2,
  },
  label: {
    opacity: .5,
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardContentInvite: React.SFC<InjectedProps> = ({
  classes,
  name,
  photoUrl,
  entryFee,
  ...props
}) => {
  // TODO: translation key(s) needed

  return (
    <GameCardContent
      wrap="nowrap"
      alignItems="center"
      {...props}
    >
      <Grid xs zeroMinWidth item>
        <Grid alignItems="center" direction="row" wrap="nowrap" container>
          <Grid className={classes.padded} item>
            <Avatar className={classes.avatar} src={photoUrl || defaultAvatar} />
          </Grid>
          <Grid zeroMinWidth item>
            <Typography className={classes.title} variant="body1" noWrap>
              {name}
            </Typography>
            <Typography className={classNames(classes.title, classes.label)} noWrap>
              challenged you
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid className={classes.separator} item />

      <Grid xs zeroMinWidth item>
        <Grid alignItems="center" direction="row" wrap="nowrap" justify="flex-end" container>
          <Grid item>
            <Coin className={classes.entryFee} currencyClassName={classes.entryFeeCurrency} value={entryFee} />
          </Grid>
          <Grid zeroMinWidth className={classes.padded} item>
            <Typography className={classes.title} variant="body1" noWrap>
              Entry
            </Typography>
            <Typography className={classNames(classes.title, classes.label)} noWrap>
              Fee
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </GameCardContent>
  )
}

export default withStyles(styles)(GameCardContentInvite)
